/** The backend rejects communication read state requests with more ids than this. */
export const MAX_COMMUNICATION_IDS_PER_REQUEST = 1000;
